import { FunctionComponent, createContext, useReducer } from 'react';
import { IState } from '../types';
import reducer, { initialState } from './reducer';

export const AppContext = createContext<IState | any>(initialState);

export const AppProvider: FunctionComponent = (props): JSX.Element => {
  let _initialState = initialState;

  let stateBackup: IState;
  try {
    const appState = localStorage.getItem('appState') || '{}';
    stateBackup = JSON.parse(appState);
  } catch {
    console.error("Couldn't read local storage state");
    stateBackup = initialState;
  }
  if (Object.keys(stateBackup).length) {
    _initialState = { ...initialState, ...stateBackup };
  }

  const [state, dispatch] = useReducer(reducer, _initialState);

  localStorage.setItem('appState', JSON.stringify(state));
  sessionStorage.setItem('prePlanType', state?.preInspectionModel?.prePlanType);

  return (
    <AppContext.Provider
      value={{
        state,
        dispatch,
      }}
    >
      {props.children}
    </AppContext.Provider>
  );
};
